import { SiteActivityLog } from '../../../models';

export class SiteActivityLogLogicServiceModel {
    siteActivityLogs: SiteActivityLog[] = [];
    isLoading = false;
    pageSizes = [20, 50, 100];
}
